import { createUseStyles } from 'react-jss';

import { mixins } from 'resources/styles/mixins';

const useStyles = createUseStyles(() => ({
  highlighted: {
    borderRadius: '4px',
    color: 'var(--primary-main)',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px',

    '&:not(.pd)': {
      ...mixins.getStaticIconSize?.(20),

      '@media screen and (min-width: 1441px)': {
        ...mixins.getStaticIconSize?.(24),
      },
    },

    '&.pd': {
      padding: '6px',
    },

    '&.danger': {
      color: 'var(--error-main)',
    },

    '&:hover, &.hoverable-action:hover': {
      backgroundColor: 'var(--primaryLightToPrimaryMain)',

      '&, & svg, & .viboIcon': {
        color: 'var(--buttonActiveToWhite)!important',
      },
    },
  },
}));

export default useStyles;
